import { Edit as EditIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Container,
  CssBaseline,
  Grid,
  Toolbar,
  Typography,
} from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router'
import { ListActions, ListStoreStates } from '.'
import { EditButton, List, ListItemText, Paper } from './styles'

type OwnProps = {}

type ListProps = OwnProps & ListStoreStates & ListActions

type ListStates = {
  expandedId: string | null
}

class NList extends React.Component<ListProps, ListStates> {
  constructor(props: ListProps) {
    super(props)

    this.state = {
      expandedId: null,
    }

    // お知らせ一覧の読み込み
    props.load()
  }

  onChangeExpansionPanel(notificationId: string) {
    const { expandedId } = this.state
    this.setState({
      expandedId: notificationId === expandedId ? null : notificationId,
    })
  }

  render = (): React.ReactNode => {
    const { expandedId } = this.state
    const { auth, notifications } = this.props
    const isEditor = auth.user?.isEditor || false

    return (
      <Container>
        <CssBaseline />
        <Paper>
          <List>
            <li>
              クチヨミ
              <ListItemText variant="body2" component="p">
                九州工業大学 齊藤剛史研究室が提供する機械読唇技術に関するサービスです。
              </ListItemText>
            </li>
            <li>
              読唇デモ（25単語）
              <ListItemText variant="body2" component="p">
                日本語25単語を対象とした読唇技術のデモを体験できます。
                デモは機械読唇技術の研究成果を紹介することを目的としています。
              </ListItemText>
            </li>
            <li>
              発話シーン投稿
              <ListItemText variant="body2" component="p">
                認識精度を向上するために発話シーン投稿の協力をお願いしています。
              </ListItemText>
            </li>
          </List>
        </Paper>
        <Paper>
          {isEditor && (
            <Toolbar>
              <Grid size="grow">
                <Typography fontWeight="bold">お知らせ</Typography>
              </Grid>
              <Button variant="contained" color="primary" sx={{ mx: 1 }} component={RouterLink} to="/notifications/new">
                新規追加
              </Button>
            </Toolbar>
          )}

          {notifications.items.length === 0 && <Typography variant="h6">現在お知らせはありません</Typography>}

          {notifications.items.map((row) => (
            <Accordion
              key={row.id}
              expanded={expandedId === row.id}
              onChange={() => this.onChangeExpansionPanel(row.id)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Grid
                  container
                  sx={{
                    alignItems: 'center',
                  }}>
                  {isEditor && (
                    <RouterLink to={`/notifications/${row.id}/edit`}>
                      <EditButton aria-label="edit" size="large">
                        <EditIcon />
                      </EditButton>
                    </RouterLink>
                  )}
                  <Typography sx={{ width: 200 }}>{row.updatedDate}</Typography>
                  <Typography fontWeight="bold">{row.title}</Typography>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{row.content}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      </Container>
    )
  }
}

export default NList
